import React from "react";
import ProjectList from "../components/Dashboard/ProjectList";
import "./Dashboard.css";
import ReportPreview from "../components/Reports/ReportPreview";

const Dashboard = () => {
  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        <ProjectList />
        <ReportPreview />
      </div>
    </div>
  );
};

export default Dashboard;
